export default __webpack_public_path__ + "images/rango-back-icon_1e35c0.svg";